import React from "react";

export interface StepDef {
  key: string;
  label: string;
}

interface Props {
  steps: StepDef[];
  currentIndex: number;
  onStepClick?: (index: number) => void;
  stepOfLabel: string; // e.g. "Korak"
  ofLabel: string; // e.g. "od"
}

const BookingProgress: React.FC<Props> = ({ steps, currentIndex, onStepClick, stepOfLabel, ofLabel }) => {
  const pct = ((currentIndex + 1) / steps.length) * 100;

  return (
    <div className="pab-progress">
      {/* Mobile: compact "Korak X od N" + thin bar */}
      <div className="pab-progress__mobile">
        <div className="pab-progress__bar">
          <div className="pab-progress__bar-fill" style={{ width: `${pct}%` }} />
        </div>
        <div className="pab-progress__label">
          {stepOfLabel} {currentIndex + 1} {ofLabel} {steps.length} · {steps[currentIndex]?.label}
        </div>
      </div>

      {/* Desktop: full step row */}
      <div className="pab-progress__desktop">
        {steps.map((s, i) => {
          const state = i < currentIndex ? "done" : i === currentIndex ? "active" : "upcoming";
          const clickable = !!onStepClick && i < currentIndex;
          return (
            <React.Fragment key={s.key}>
              <button
                type="button"
                className={`pab-progress__step pab-progress__step--${state}`}
                onClick={() => clickable && onStepClick!(i)}
                disabled={!clickable}
              >
                <span className="pab-progress__dot">
                  {state === "done" ? "✓" : i + 1}
                </span>
                <span className="pab-progress__step-label">{s.label}</span>
              </button>
              {i < steps.length - 1 && <span className="pab-progress__connector" />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default BookingProgress;
